import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateObjectValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import type { IncomingTrafficDescription } from "../../types/description.dto";
import type { IIncomingTrafficFilterDto } from "../../types/leadsSearchFilters.dto";

export default class FindIncomingTrafficFilter extends FilterPanelBaseFilter<
    IIncomingTrafficFilterDto,
    IncomingTrafficDescription
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IIncomingTrafficFilterDto, IncomingTrafficDescription>) {
        super(deps);
    }

    isFilterDirty(currentValue: IIncomingTrafficFilterDto | undefined): boolean {
        return JSON.stringify(this.initialDtoValue ?? {}) !== JSON.stringify(currentValue ?? {});
    }

    calculateValueDelta(
        previousValue: IIncomingTrafficFilterDto | undefined,
        newValue: IIncomingTrafficFilterDto | undefined,
    ): FilterValueDelta<IIncomingTrafficFilterDto> {
        return calculateObjectValueDelta<Partial<IIncomingTrafficFilterDto>>(previousValue, newValue);
    }
}
